// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-manual-create/inventory-manual-create.less
// module id = 3500
// module chunks = 0